<template>
  <div id="vue-app">
      <div class="container mt">
      <div class="form-container">
        <div tabindex="0" role="alert" class="error-container" id="error">
          <div class="error" v-if="error">
              <p>An account does not exist with that email.</p>
          </div>
        </div>
        <div tabindex="0" role="alert" class="confirmation-container" id="confirm">
          <div class="confirmation" v-if="confirmation">
              <p>An email has been sent to the provided email address with a link to reset your password.</p>
          </div>
        </div>
          <form>
                <label for="username">Email</label>
                <input type="text" class="" name="username" id="username" v-model="username">
            </form>
            <button v-on:click="send">Send password reset link</button>
        </div>
        </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ApplicationSendResetPassword',

  data() {
    return {
        username: '',
        error: false,
        confirmation: false,
    }
  },
  created() {
    window.scrollTo(0,0);

  },
  methods: {
      send() {
          
          axios.post('/wp-json/HCLRC/v1/public-user-password-reset/', {
            username: this.username
            }).then(res => {
                console.log("Password Reset Response:", res);

                if (res.data.data.status == "OK") {
                    this.$set(this, 'confirmation', true);
                    window.scrollTo(0,0);
                    document.getElementById('confirm').focus();

                } else {
                    this.$set(this, 'error', true);
                    window.scrollTo(0,0);
                    document.getElementById('error').focus();
                }
            
        })
        .catch(function (error) {
            // if an error occurs, print that error
            console.log(error);

        });
      },
  }
}
</script>
<!-- styling for the component -->
<style lang="scss">
.error {
    background-color: #dc3b43;
    padding: 1rem;
    margin-bottom: 2rem;
    p {
        font-weight: 600;
        color: #fff;
        margin-bottom: 0;
    }
}
.confirmation {
    border: 3px solid rgba(37, 114, 130, .3);
    padding: .5rem;
    text-align: center;
    margin-bottom: 2rem;
    p {
        font-weight: 700;
    }
}
.form-container {
    text-align: center;
    form {
    display: flex;
    flex-direction: column;
    width: 40%;
    margin: 0 auto;
    label {
        font-weight: 600;
        margin-bottom: 0;
        text-align: left;
    }
    input {
        font-family: "neue-haas-unica";
        border: 1px solid rgba(37, 114, 130, .3);
        margin-bottom: 1rem;
        font-size: 1rem;

        
    }
}
button {
    font-size: 1.25rem;
    font-family: 'din-2014';
    font-weight: 600;
    padding: .75rem 5rem;
    background-color: #dc3b43;
    color: #fff;
    font-size: 1rem;
    margin-bottom: 1rem;
    cursor: pointer;
    transition: all .5s;

    &:hover, &:focus, &.active {
        background-color: #A12127;
    }
}
}


</style>


// WEBPACK FOOTER //
// src/components/Application/ApplicationSendResetPassword.vue